import firebase from "firebase/app";
import { message } from "antd";
import api from "./axiosInstance";

type PromiseCallback = (value?: any) => void;

const fetchAllBookingsAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { courtId } = payload;
  firebase
    .firestore()
    .collection("bookings")
    .where("courtId", "==", courtId)
    .where("status", "!=", "cancelled")
    .get()
    .then((querySnapshot) => {
      const allBookings: any[] = [];
      querySnapshot.forEach((doc) => {
        allBookings.push({ ...doc.data(), id: doc.id });
      });
      resolve(allBookings);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error fetch bookings: ", error);
      reject(error);
    });
};

const createBookingAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { data } = payload;
  api.post("create_booking", { ...data, status: "booked" })
    // api.post("create_booking_test", { ...data, status: "booked" })
    .then((response) => {
      console.log("response:", response);
      const { success, errorMessage } = response.data;
      if (success) {
        message.success("Success! New book has been created!");
        resolve(data);
      }
      else {
        message.error(errorMessage);
        reject(errorMessage);
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      message.error("Oop! Something went wrong!");
      reject(error);
    });
};

const editBookingAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { courtId, startTime, endTime, key, name, notes } = payload;
  const currentTime = new Date().toISOString();
  firebase
    .firestore()
    .collection("bookings")
    .doc(key)
    .update({
      courtId,
      name,
      notes,
      startTime: new Date(startTime).toISOString(),
      endTime: new Date(endTime).toISOString(),
      updatedAt: currentTime,
    });
  firebase
    .firestore()
    .collection("courts")
    .where("clubId", "==", courtId)
    .get()
    .then((querySnapshot) => {
      const allCourts: any[] = [];
      querySnapshot.forEach((doc) => {
        allCourts.push({ ...doc.data(), key: doc.id });
        resolve(allCourts);
      });
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error fetch clubs: ", error);
      reject(error);
    });
};

const deleteBookingAPI = (payload: any) => (
  resolve: PromiseCallback,
  reject: PromiseCallback
) => {
  const { id, courtId } = payload;
  firebase
    .firestore()
    .collection("bookings")
    .doc(id)
    .delete()
    .then(() => {
      firebase
        .firestore()
        .collection("bookings")
        .where("courtId", "==", courtId)
        .get()
        .then((querySnapshot) => {
          const allBookings: any[] = [];
          if (querySnapshot.docs.length) {
            querySnapshot.forEach((doc) => {
              allBookings.push({ ...doc.data(), id: doc.id });
              resolve(allBookings);
            });
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error fetch bookings: ", error);
          reject(error);
        });
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error("Error removing document: ", e);
      reject(e);
    });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseFetchAllBookings = (payload: any): any =>
  new Promise(fetchAllBookingsAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseCreateBooking = (payload: any): any =>
  new Promise(createBookingAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseEditBooking = (payload: any): any =>
  new Promise(editBookingAPI(payload));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const firebaseDeleteBooking = (payload: any): any =>
  new Promise(deleteBookingAPI(payload));
